<template>  
  <h1 class="title">Privacy Policy</h1>
  <div class="d1">
    <div class="d2">
      <p><span class="d2a">Effective Date:</span> {{new Date().toLocaleString('default', {month: 'long', day: 'numeric', year: 'numeric'})}}</p>

      <p>At In Your Hands ("we", "our", "us"), your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website <a href="https://inyourhands-llc.com">inyourhands-llc.com</a> and use the contact form to reach us.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect personal information through:</p>
      <ul>
          <li>Contact Form: First Name, Last Name, Email Address, Phone, and Your Message.</li>
          <li>Google Analytics: Information about your use of our website, such as pages visited, time spent, browser type, IP address, and device type.</li>
          <li>Cookies and Tracking Technologies: Our website may use cookies to improve your browsing experience and collect analytics data.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>The information we collect is used to:</p>
      <ul>
          <li>Respond to inquiries and messages submitted through the contact form.</li>
          <li>Analyze website traffic and usage patterns to improve our website.</li>
          <li>Ensure the website functions properly and provide a better user experience.</li>
      </ul>

      <h2>3. Google Analytics and Cookies</h2>
      <p>We use Google Analytics to collect information about how visitors use our website. This helps us understand traffic patterns and improve user experience. Google Analytics uses cookies to track your interactions with our site. The data collected may include:</p>
      <ul>
          <li>Your IP address (anonymized where applicable).</li>
          <li>Pages visited and time spent on each page.</li>
          <li>Browser type, operating system, and device used.</li>
      </ul>

      <p>You can learn more about how Google collects and processes data <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">here</a>.</p>

      <h3>Managing Cookies</h3>
      <p>You can control or disable cookies through your browser settings. Note that disabling cookies may affect the functionality of the website.</p>

      <h2>4. How We Share Your Information</h2>
      <p>We do not sell, trade, or rent your personal information to third parties. However, we may disclose your information if required by law or to protect our legal rights.</p>

      <h2>5. Data Security</h2>
      <p>We take reasonable steps to protect your personal information, but no method of transmission over the internet is entirely secure. Please contact us if you have security concerns.</p>

      <h2>6. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
          <li>Access the personal data we hold about you.</li>
          <li>Request correction or deletion of your personal data.</li>
          <li>Opt-out of analytics tracking by disabling cookies in your browser or using tools like the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.</li>
      </ul>

      <h2>7. External Links</h2>
      <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites.</p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>We may update this policy periodically. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy regularly.</p>

      <h2>9. Contact Us</h2>
      <p>If you have questions about this policy, contact us at:</p>
      <p>Email: <a href="mailto:eric.k@inyourhands-llc.com">eric.k@inyourhands-llc.com</a></p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'privacypolicy',
    data() {
      return {
        minw: 0,
      }
    },
    mounted() {            
      this.updateViewport();    
      window.addEventListener('resize', this.updateViewport); 
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.updateViewport);
      window.removeEventListener('resize', this.windowSize);
    },
    methods: {
      updateViewport() {
        this.minw = window.screen.width*.75 + 'px';
      }
    }      
  }
</script>
<style scoped>
h1 {
  width:100%;
  text-align: center;
}
h2{
    font-weight:250;
    font-size:24px;    
    text-decoration: underline;
}
.d1 {
  width: 100%;  
  min-width: v-bind(minw);  
  margin-top: 20px;
  margin-bottom: 50px;
  font-family: 'Akatab';
  color: v-bind(colorRed);
  font-size: 20px;
}
.d2 {
  width: 60%;
  margin-left: 20%;
}
.skip {
  position: absolute;
  left: -10000px;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.skip:focus {
  left:0;
  width: auto;
  height: auto;
}
.title {
  min-width: v-bind(minw);
  font-family: 'Anonymous Pro';
  font-size: 60px;
  color: v-bind(colorRed);
  position:absolute;
  min-width: v-bind(minw);
  top: 130px;
  display: flex;
  justify-content: center;
  width: 100%;
  text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
}
@media only screen and (max-width: 900px) {
  .d2 {
    width: 90%;
    margin-left: 5%;
  }
  .title { 
  font-size:40px;
}
}
</style>
